import DocumentCardComponent from "@/components/DocumentCard";
import RichTextImage from "./RichTextImage";
import { PortableText as PortableTextComponent } from "@portabletext/react";
import {
  Normal,
  Heading2,
  Heading3,
  Heading4,
  Heading5,
  BulletList,
  NumberList,
  DocumentCardsContainer,
  Strong,
  Span,
  Italic,
  Anchor,
} from "./styles";
import LinkComponent from "next/link";

// Cast to fix React 17 + @types/react 18 compatibility issue
const DocumentCard = DocumentCardComponent as any;
const PortableText = PortableTextComponent as any;
const Link = LinkComponent as any;

export type SimpleRichTextProps = {
  body: Record<string, any>;
  types?: Record<string, any>;
};

const DocumentCards: React.FC<any> = (props) => {
  return (
    <DocumentCardsContainer>
      {props?.files &&
        props?.files?.map((file: any) => (
          <DocumentCard key={file?._key} {...file} />
        ))}
    </DocumentCardsContainer>
  );
};

const SimpleRichText: React.FC<SimpleRichTextProps> = (props) => {
  const { body } = props;
  return (
    <PortableText
      value={body}
      components={{
        block: {
          normal: ({ children }: any) => <Normal>{children}</Normal>,
          h2: ({ children }: any) => <Heading2>{children}</Heading2>,
          h3: ({ children }: any) => <Heading3>{children}</Heading3>,
          h4: ({ children }: any) => <Heading4>{children}</Heading4>,
          h5: ({ children }: any) => <Heading5>{children}</Heading5>,
        },
        list: {
          bullet: ({ children }: any) => <BulletList>{children}</BulletList>,
          number: ({ children }: any) => <NumberList>{children}</NumberList>,
        },
        marks: {
          red: ({ children }: any) => <Span $red={true}>{children}</Span>,
          strong: ({ children }: any) => <Strong>{children}</Strong>,
          em: ({ children }: any) => <Italic>{children}</Italic>,
          internalLink: ({ children, value }: any) => {
            if (value.slug) {
              return (
                <Link href={`/${value.slug}`} passHref>
                  <Anchor href={`/${value.slug}`}>{children}</Anchor>
                </Link>
              );
            } else {
              console.warn(
                `An internal link hasn't been set. Please check this sentence: "${children}"`
              );
              return <Anchor>{children}</Anchor>;
            }
          },
          externalLink: ({ children, value }: any) => (
            <Anchor
              href={value.url.url}
              target={`${value.url?.blank ? "_blank" : ""}`}
              rel="noreferrer"
            >
              {children}
            </Anchor>
          ),
          mailLink: ({ children, value }: any) => (
            <Anchor href={`mailto:${value.url}`} rel="noreferrer">
              {children}
            </Anchor>
          ),
        },
        types: {
          files: (props: Record<string, any>) => {
            const DocumentCardsTyped = DocumentCard as any;
            if (props?.value?.files) {
              return (
                <DocumentCardsContainer>
                  {props?.value?.files?.map((file: any) => (
                    <DocumentCardsTyped key={file?._key} {...file} />
                  ))}
                </DocumentCardsContainer>
              );
            }
            return <DocumentCardsTyped {...props.value} />;
          },
          richTextImage: RichTextImage,
          ...props.types, // you can safely spread an undefined value, in fact typescript doesn't complain
        },
      }}
    />
  );
};

export default SimpleRichText;
